document.addEventListener('DOMContentLoaded', function() {
    const regionButtons = document.querySelectorAll('.region-btn');
    const prefectureButtons = document.getElementById('prefectureButtons');
    const areaList = document.getElementById('areaList');
    const areaButtons = document.getElementById('areaButtons');
    const searchInput = document.getElementById('areaSearch');
    const searchButton = document.getElementById('searchButton');

    // ポップアップのスタイルを動的に追加
    const popupStyles = `
        .popup {
            display: none;
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.5);
            z-index: 1000;
        }
        .popup-content {
            position: relative;
            background-color: white;
            margin: 15% auto;
            padding: 30px;
            width: 80%;
            max-width: 600px;
            border-radius: 8px;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
        }
        .close-btn {
            position: absolute;
            right: 20px;
            top: 10px;
            font-size: 28px;
            font-weight: bold;
            cursor: pointer;
            color: #333;
        }
    `;

    // スタイルタグを作成して追加
    const styleSheet = document.createElement("style");
    styleSheet.innerText = popupStyles;
    document.head.appendChild(styleSheet);

    // ポップアップ要素を動的に作成
    const popupHTML = `
        <div id="regionPopup" class="popup">
            <div class="popup-content">
                <span class="close-btn">&times;</span>
                <div id="selectedRegion" class="region-title"></div>
                <div class="prefecture-list">
                    <!-- 都道府県リストが動的に追加されます -->
                </div>
            </div>
        </div>
    `;

    // ポップアップをbodyに追加
    document.body.insertAdjacentHTML('beforeend', popupHTML);

    // ポップアップをbodyに追加した後の要素取得のみを保持
    const popup = document.getElementById('regionPopup');
    const closeBtn = document.querySelector('.close-btn');
    const prefectureList = document.querySelector('.prefecture-list');
    const selectedRegion = document.getElementById('selectedRegion');

    // 地域ボタンクリックイベント
    regionButtons.forEach(button => {
        button.addEventListener('click', function(e) {
            e.preventDefault(); // デフォルトの挙動を防止
            const region = this.dataset.region;
            const prefectures = prefecturesByRegion[region];
            
            if (prefectures) {
                selectedRegion.textContent = `${getRegionName(region)}`;
                prefectureList.innerHTML = '';

                prefectures.forEach(prefecture => {
                    const div = document.createElement('div');
                    div.className = 'prefecture-item';
                    div.textContent = prefecture.name;
                    
                    div.addEventListener('click', (e) => {
                        e.preventDefault(); // デフォルトの挙動を防止
                        if (prefecture.subAreas) {
                            prefectureList.innerHTML = '';
                            selectedRegion.textContent = `${prefecture.name}のエリア一覧`;
                            
                            prefecture.subAreas.forEach(subArea => {
                                const subDiv = document.createElement('div');
                                subDiv.className = 'prefecture-item';
                                subDiv.textContent = subArea.name;
                                subDiv.addEventListener('click', (e) => {
                                    e.preventDefault();
                                    window.location.href = subArea.url;
                                });
                                prefectureList.appendChild(subDiv);
                            });
                        } else {
                            window.location.href = prefecture.url;
                        }
                    });
                    
                    prefectureList.appendChild(div);
                });

                popup.style.display = 'block';
            }
        });
    });

    // ポップアップを閉じる
    closeBtn.addEventListener('click', () => {
        popup.style.display = 'none';
    });

    // ポップアップ外クリックで閉じる
    window.addEventListener('click', (e) => {
        if (e.target === popup) {
            popup.style.display = 'none';
        }
    });

    function getRegionName(region) {
        const names = {
            hokkaido: '北海道',
            tohoku: '東北',
            kanto: '関東',
            chubu: '中部',
            kansai: '関西',
            chugoku: '中国',
            shikoku: '四国',
            kyushu: '九州・沖縄'
        };
        return names[region] || region;
    }

    // 検索機能
    searchButton.addEventListener('click', performSearch);
    searchInput.addEventListener('keypress', function(e) {
        if (e.key === 'Enter') {
            performSearch();
        }
    });

    function performSearch() {
        const searchTerm = searchInput.value.toLowerCase();
        const filteredAreas = areaData.filter(area => 
            area.name.toLowerCase().includes(searchTerm)
        );
        
        selectedRegion.textContent = '検索結果';
        prefectureButtons.innerHTML = '';

        filteredAreas.forEach(area => {
            const button = document.createElement('div');
            button.className = 'area-btn';
            button.innerHTML = `<a href="${area.url}">${area.name}</a>`;
            prefectureButtons.appendChild(button);
        });

        areaList.style.display = 'block';
    }
}); 